const required = value => {
   return  (value === null || value === '' || typeof value === 'undefined') ? 'This field is required' : undefined;
} 
export default required;